import './privacy-policy-table.scss';

export class PrivacyPolicyTable {}
